﻿export class AccessDenied {
}